import React from "react";

const Nav = () => {
  return (
    <div className="nav">
      <div className="ul">
        <a href="#top">HOME</a>
        <a href="#projects">PROJECTS</a>
        <a href="#contact">CONTACT</a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://drive.google.com/file/d/1MHo7nPIVFd_rPSGaqr2Dm3qcR06elbTJ/view"
        >
          RESUME
        </a>
      </div>
      <hr />
    </div>
  );
};

export default Nav;
